export default __webpack_public_path__ + "static/life_at_02-8209421adca3df012632a7d1f9e41c5b.jpg";